import * as React from 'react';
import classnames from 'classnames';

import './style.scss';

interface IAttachButtonProps {
  id: string;
  onClick: TButtonOnClick;
  multiple?: boolean;
  accept?: string;
}

interface IAttachButtonState {}

export default class AttachButton extends React.Component<IAttachButtonProps, IAttachButtonState> {
  static defaultProps = {
    onClick: () => null,
    multiple: true,
    accept: '',
  };

  render() {
    // eslint-disable-next-line react/prop-types
    const { id, children, multiple, accept, onClick } = this.props;

    return (
      <div className={classnames('camera-btn')}>
        {children || <label htmlFor={id}>Camera</label>}
        <input id={id} type="file" accept={accept} onChange={onClick} multiple={multiple} />
      </div>
    );
  }
}
